import React, {useEffect} from 'react';
import {t} from 'i18next';
import ArrModal from '../../common/arr-modal/ArrModal';
import {ToastType} from '../../../shared/constants';
import {useDeleteClient} from '../../../hooks/clients/useClients';
import {IClient} from '../../../api/types/client.type';

interface Props {
  open: boolean;
  onClose: () => void;
  selectedClient: IClient | null;
  triggerToast: (message: string, status: ToastType[]) => void;
}

const DeleteClientModal: React.FC<Props> = ({
  open,
  onClose,
  selectedClient,
  triggerToast,
}) => {
  const {mutate: deleteClient} = useDeleteClient();

  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        (
          document.getElementsByClassName('modal-close')[0] as HTMLElement
        ).focus();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [open]);

  const handleConfirmDelete = () => {
    deleteClient(selectedClient?.entityId ?? 0, {
      onSuccess: (data) => {
        triggerToast(data.message, [ToastType.Success]);
        onClose();
      },
      onError: (data) => {
        triggerToast(data.message || t('manageClients.deleteError'), [
          ToastType.Error,
        ]);
        onClose();
      },
    });
  };

  return (
    <ArrModal
      showModal={open}
      onClose={onClose}
      title={t('common.delete')}
      description={t('manageClients.deleteMessage')}
      autoFocusCloseButton={true}
      dataTestId="delete-client-modal"
      buttons={[
        {
          id: '1',
          label: t('common.no'),
          onClick: onClose,
          variant: 'secondary',
          dataTestId: 'delete-modal-cancel-btn',
        },
        {
          id: '2',
          label: t('common.yes'),
          onClick: handleConfirmDelete,
          variant: 'primary',
          dataTestId: 'delete-modal-confirm-btn',
        },
      ]}
    />
  );
};

export default DeleteClientModal;
